import * as api from '../connectivity/api.assignment_files';
import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import * as types from '../constants/actionTypes';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import _ from 'lodash';

let fileDownload = require('react-file-download');


export function* doRequestAssignmentFileDownload(action) {
    yield put(showLoading());

    try{
        const file = yield call(api.downloadAssignmentFile, action.payload.file_id, action.payload.file_size);

        yield put({
            type: types.ASSIGNMENT__FILE__DOWNLOAD__REQUEST__SUCCEEDED,
            file: file,
            file_name : action.payload.file_name
        });
    } catch (e) {
        yield put({
            type: types.ASSIGNMENT__FILE__DOWNLOAD__REQUEST__FAILED,
            files: action.payload,
            message: e.message
        });
    }

    yield put(hideLoading());
}

export function* doRequestAssignmentFileUpload(action) {
    try{
        const file = yield call(api.uploadAssignmentFile, action.payload);

        yield put({
            type: types.ASSIGNMENT__FILE__UPLOAD__REQUEST__SUCCEEDED,
            file: file
        });
    } catch (e) {
        if (e.statusCode === 400) {
            yield put({
                type: types.ASSIGNMENT__FILE__UPLOAD__BAD__REQUEST,
                files: action.payload,
                data: e.data
            });
        } else {
            yield put({
                type: types.ASSIGNMENT__FILE__UPLOAD__REQUEST__FAILED,
                files: action.payload,
                message: e.message
            });
        }
    }
}

export function* doRequestAssignmentFileDownloadSucceeded(action) {
    yield (fileDownload(action.file, action.file_name));

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "File: "+action.file_name+" downloaded",
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'files.doRequestAssignmentFileDownload'
        }
    });
}

export function* doRequestAssignmentFileDownloadFailed(action) {
    const { message } = action.message;

    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "Download failed" + (message ? ": " + message : ""),
            level: 'error'
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'files.doRequestAssignmentFileDownload'
        }
    });
}

export function* doRequestAssignmentFileUploadSucceeded(action) {
    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "File: "+action.file.name+" uploaded successfully",
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'files.doRequestAssignmentFileUpload'
        }
    });
}

export function* doRequestAssignmentFileUploadFailed(action) {
    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "File upload failed",
            level: 'error'
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'files.doRequestAssignmentFileUpload'
        }
    });
}

export function* doRequestAssignmentFileUploadBadRequest(action) {
    if (action.data && action.data.form && action.data.form.children) {
        let {form} = action.data,
            fields = _.omitBy(
                _.mapValues(form.children, (field) => {
                    return field.errors;
                }),
                _.isNil
            )
        ;

        for (let errors in fields) {
            for (let i=0;i<fields[errors].length;i++) {
                yield put({
                    type: types.ADD_NOTIFICATION,
                    payload: {
                        message: fields[errors][i],
                        level: 'error'
                    }
                });
            }
        }
    }
}

export function* doRequestAssignmentFileDelete(action) {
    yield put(showLoading());

    try{
        const file = yield call(api.removeAssignmentFile, action.payload.file_id);

        yield put({
            type: types.ASSIGNMENT__FILE__DELETE__REQUEST__SUCCEEDED,
            file: file
        });
    } catch (e) {
        yield put({
            type: types.ASSIGNMENT__FILE__DELETE__REQUEST__FAILED,
            files: action.payload,
            message: e.message
        });
    }

    yield put(hideLoading());
}

export function* doRequestAssignmentFileDeleteSucceeded(action) {
    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "File: "+action.file.name+" deleted",
            level: 'success'
        }
    });

    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'files.doRequestAssignmentFileDelete'
        }
    });
}

export function* doRequestAssignmentFileDeleteFailed(action) {
    yield put({
        type: types.ADD_NOTIFICATION,
        payload: {
            message: "File delete failed",
            level: 'error'
        }
    });

    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'files.doRequestAssignmentFileDelete'
        }
    });
}


export function* watchRequestAssignmentFileUpload() {
    yield* takeEvery(types.ASSIGNMENT__FILE__UPLOAD__REQUESTED, doRequestAssignmentFileUpload);
}

export function* watchRequestAssignmentFileUploadSucceeded() {
    yield* takeEvery(types.ASSIGNMENT__FILE__UPLOAD__REQUEST__SUCCEEDED, doRequestAssignmentFileUploadSucceeded);
}

export function* watchRequestAssignmentFileUploadFailed() {
    yield* takeEvery(types.ASSIGNMENT__FILE__UPLOAD__REQUEST__FAILED, doRequestAssignmentFileUploadFailed);
}

export function* watchRequestAssignmentFileUploadBadRequest() {
    yield* takeEvery(types.ASSIGNMENT__FILE__UPLOAD__BAD__REQUEST, doRequestAssignmentFileUploadBadRequest);
}

export function* watchRequestAssignmentFileDownload() {
    yield* takeEvery(types.ASSIGNMENT__FILE__DOWNLOAD__REQUESTED, doRequestAssignmentFileDownload);
}

export function* watchRequestAssignmentFileDownloadSucceeded() {
    yield* takeEvery(types.ASSIGNMENT__FILE__DOWNLOAD__REQUEST__SUCCEEDED, doRequestAssignmentFileDownloadSucceeded);
}

export function* watchRequestAssignmentFileDownloadFailed() {
    yield* takeEvery(types.ASSIGNMENT__FILE__DOWNLOAD__REQUEST__FAILED, doRequestAssignmentFileDownloadFailed);
}


export function* watchRequestAssignmentFileDelete() {
    yield* takeEvery(types.ASSIGNMENT__FILE__DELETE__REQUESTED, doRequestAssignmentFileDelete);
}

export function* watchRequestAssignmentFileDeleteSucceeded() {
    yield* takeEvery(types.ASSIGNMENT__FILE__DELETE__REQUEST__SUCCEEDED, doRequestAssignmentFileDeleteSucceeded);
}

export function* watchRequestAssignmentFileDeleteFailed() {
    yield* takeEvery(types.ASSIGNMENT__FILE__DELETE__REQUEST__FAILED, doRequestAssignmentFileDeleteFailed);
}


/** WEBPACK FOOTER **
 ** ./src/sagas/assignment_files.saga.js
 **/